<template>
  <div class="container-fluid">
    <div class="row top-row">
      <div class="col text-center">
        <h5 class="no-bottom-margin">Schedule A Tour</h5>
      </div>
    </div>
    <div class="row calendar">
      <div class="col very-small-col text-center border day" v-on:click="setDate(today)">
        <p>Today</p>
        <h3>{{ today.getDate() }}</h3>
        <p>{{ months[today.getMonth()] }}</p>
      </div>
      <div class="col very-small-col text-center border day" v-on:click="setDate(tomorrow)">
        <p>Tomorrow</p>
        <h3>{{ tomorrow.getDate() }}</h3>
        <p>{{ months[tomorrow.getMonth()] }}</p>
      </div>
      <div class="col very-small-col text-center border day" v-on:click="setDate(dayAfterTomorrow)">
        <p>{{ daysOfTheWeek[dayAfterTomorrow.getDay()]}}</p>
        <h3>{{ dayAfterTomorrow.getDate() }}</h3>
        <p>{{ months[dayAfterTomorrow.getMonth()] }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <button class="btn btn-primary" v-on:click="showScheduleModal">Schedule</button>
        <p>100% Free, No Commitment</p>
      </div>
    </div>
    <hr>
    <schedule-showing-modal ref="scheduleModal" v-bind:initialDate="date"></schedule-showing-modal>
  </div>
</template>

<script>
import ScheduleShowingModal from './ScheduleShowingModal.vue'

export default {
  components: {
    ScheduleShowingModal
  },
  data () {
    return {
      date: null
    }
  },
  methods: {
    showScheduleModal () {
      this.$refs.scheduleModal.showScheduleModal()
    },
    hideScheduleModal () {
      this.$refs.scheduleModal.hideScheduleModal()
    },
    setDate (day) {
      this.date = day.getFullYear() + '-' +
                  ('0' + (day.getMonth() + 1)).slice(-2) + '-' +
                  ('0' + day.getDate()).slice(-2)
      this.showScheduleModal()
    }
  },
  computed: {
    today () {
      var currentDate = new Date()
      return currentDate
    },
    tomorrow () {
      var tomorrow = new Date()
      tomorrow.setDate(this.today.getDate() + 1)
      return tomorrow
    },
    dayAfterTomorrow () {
      var dayAfterTomorrow = new Date()
      dayAfterTomorrow.setDate(this.today.getDate() + 2)
      return dayAfterTomorrow
    },
    daysOfTheWeek () {
      return [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ]
    },
    months () {
      return [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
    }
  }
}
</script>

<style src="vuelendar/scss/vuelendar.scss" lang="scss"></style>
<style scoped>
.btn {
  margin-bottom: 1rem !important;
}

.day {
  cursor: pointer;
}

.top-row {
  padding-top: 1rem;
}

.very-small-col {
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.calendar {
  padding-left: .5rem;
  padding-right: .5rem;
  padding-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/rightSide/Schedule.vue